import React from 'react';

const DeleteIcon = ({ size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M17.5584 4.35832C16.2167 4.22499 14.875 4.12499 13.525 4.04999V4.04166L13.3417 2.95832C13.2167 2.19166 13.0334 1.04166 11.0834 1.04166H8.90005C6.95838 1.04166 6.77505 2.14166 6.64172 2.94999L6.46672 4.01666C5.69172 4.06666 4.91672 4.11666 4.14172 4.19166L2.44172 4.35832C2.09172 4.39166 1.84172 4.69999 1.87505 5.04166C1.90838 5.38332 2.20838 5.63332 2.55838 5.59999L4.25838 5.43332C8.62505 4.99999 13.0251 5.16666 17.4417 5.60832C17.4667 5.60832 17.4834 5.60832 17.5084 5.60832C17.8251 5.60832 18.1 5.36666 18.1334 5.04166C18.1584 4.69999 17.9084 4.39166 17.5584 4.35832Z"
      fill="currentColor"
    />
    <path
      opacity="0.3991"
      d="M16.0254 6.78334C15.8254 6.57501 15.5504 6.45834 15.2671 6.45834H4.73378C4.45044 6.45834 4.16711 6.57501 3.97544 6.78334C3.78378 6.99168 3.67544 7.27501 3.69211 7.56668L4.20878 16.1167C4.30044 17.3833 4.41711 18.9667 7.32544 18.9667H12.6754C15.5838 18.9667 15.7004 17.3917 15.7921 16.1167L16.3088 7.57501C16.3254 7.27501 16.2171 6.99168 16.0254 6.78334Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9834 14.1667C7.9834 13.8215 8.26322 13.5417 8.6084 13.5417H11.3834C11.7286 13.5417 12.0084 13.8215 12.0084 14.1667C12.0084 14.5118 11.7286 14.7917 11.3834 14.7917H8.6084C8.26322 14.7917 7.9834 14.5118 7.9834 14.1667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29199 10.8333C7.29199 10.4882 7.57181 10.2083 7.91699 10.2083H12.0837C12.4288 10.2083 12.7087 10.4882 12.7087 10.8333C12.7087 11.1785 12.4288 11.4583 12.0837 11.4583H7.91699C7.57181 11.4583 7.29199 11.1785 7.29199 10.8333Z"
      fill="currentColor"
    />
  </svg>
);

export default DeleteIcon;
